import { render, staticRenderFns } from "./ProductMediaDesktop.vue?vue&type=template&id=49113556&scoped=true&"
import script from "./ProductMediaDesktop.vue?vue&type=script&lang=js&"
export * from "./ProductMediaDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ProductMediaDesktop.vue?vue&type=style&index=0&id=49113556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49113556",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyVideo: require('/app/components/UI/UiLazyVideo.vue').default,UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default,UiSpinner: require('/app/components/UI/UiSpinner.vue').default})
